import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';

import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

import FlashOnRoundedIcon from '@mui/icons-material/FlashOnRounded';
import BatteryAlertRoundedIcon from '@mui/icons-material/BatteryAlertRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';

import * as Constants from '../../components/api/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function HistoryVoltageLogs() {
  const state = useContext(MainContext).state;
  const r7 = state.R7.split(',');
  const deviceId = state.selectedDevice;

  const ICON_COLORS = {
    heat: "#FF7043",        // orange / heat
    cool: "#4FC3F7",        // light blue
    water: "#29B6F6",       // pool / water
    time: "#BA68C8",        // timers
    power: "#FFD54F",       // electrical
    speed: "#81C784",       // motion / speed
    level: "#90A4AE",       // neutral / measurement
  };

  const rows = [
    {
      id: 0,
      label: 'Max Voltage',
      value: r7[11],
      icon: <FlashOnRoundedIcon sx={{ color: ICON_COLORS.power }} />
    },
    {
      id: 1,
      label: 'Min Voltage',
      value: r7[12],
      icon: <BatteryAlertRoundedIcon sx={{ color: ICON_COLORS.speed }} />
    },
    {
      id: 2,
      label: 'Max Voltage (24 hr)',
      value: r7[13],
      icon: <AccessTimeRoundedIcon sx={{ color: ICON_COLORS.time }} />
    },
    {
      id: 3,
      label: 'Min Voltage (24 hr)',
      value: r7[14],
      icon: <AccessTimeRoundedIcon sx={{ color: ICON_COLORS.time }} />
    }
  ];


  const sendCommand = (command, value) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        DeviceId: deviceId,
        Command: command,
        Value: value
      }),
      credentials: 'include'
    };

    fetch(Constants.baseURL + Constants.apiSendCommand, requestOptions)
      .then((response) => {
        if (response.ok) {
          toast.success('Command sent successfully. Refreshing...', {
            position: 'top-right',
            autoClose: 8000
          });

          setTimeout(() => state.refreshDeviceRF(deviceId), 4000);
          setTimeout(() => state.getUserDeviceRf(deviceId), 9000);
        } else {
          toast.error('Send failed. Try again', { autoClose: 5000 });
        }
      })
      .catch((error) => console.log('request failed', error));
  };

  const onClear = () => sendCommand('clearVoltage', '');

  return (
    <>
      <ToastContainer />

      <Typography
        component="h2"
        variant="h6"
        sx={{ color: 'white', fontWeight: 600, mb: 2 }}
      >
        Voltage Logs
      </Typography>

      <Grid container spacing={1.5}>
        {rows.map((item) => (
          <Grid item xs={12} md={6} key={item.id}>
            <Paper
              sx={{
                p: 1.5,
                height: 65,
                display: 'flex',
                alignItems: 'center',
                gap: 1.4,
                borderRadius: 2,
                bgcolor: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
                transition: '0.2s ease',
                '&:hover': {
                  bgcolor: 'rgba(255,255,255,0.08)',
                  transform: 'translateY(-2px)'
                }
              }}
            >
              {/* Icon Bubble */}
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'rgba(255,255,255,0.12)',
                  color: 'white',
                  flexShrink: 0
                }}
              >
                {item.icon}
              </Box>

              {/* Label + Value Chip */}
              <Box sx={{ flexGrow: 1 }}>
                <Typography
                  variant="subtitle2"
                  color="white"
                  sx={{ fontSize: 14, fontWeight: 700, lineHeight: 1.1 }}
                >
                  {item.label}
                </Typography>

                <Typography
                  variant="caption"
                  sx={{
                    fontSize: 13,
                    color: 'text.disabled',
                  }}
                >
                  {item.value}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}

        {/* Clear button tile */}
        <Grid item xs={12}>
          <Paper
            sx={{
              p: 2,
              textAlign: 'center',
              borderRadius: 2,
              bgcolor: 'rgba(255,255,255,0.04)',
              border: '1px solid rgba(255,255,255,0.08)'
            }}
          >
            <Button
              variant="outlined"
              onClick={onClear}
              sx={{
                color: 'white',
                borderColor: 'rgba(255,255,255,0.4)',
                textTransform: 'none',
                px: 4,
                '&:hover': {
                  borderColor: 'white',
                  bgcolor: 'rgba(255,255,255,0.08)'
                }
              }}
            >
              Clear Logs
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
